export default __webpack_public_path__ + "static/media/billing-cost-icon.38c1143d.svg";